import React from 'react';
import { Link } from 'react-router-dom';
import { RoundCard } from '..';
import './index.css'

export const StatusCard = ({ title, count,icon,bgColor }) => {
    const circle={
        "border-radius": "50%",
        "height": "50px",
        "width": "50px",
        "display": "flex",
        "align-items": "center",
        "justify-content": "center",
        "background":  bgColor,
    }
    return (
        <div className='status-card box'>
        
                <div className='row status-card-row'>
                    <div style={circle}>
                        <img src={icon}/>
                    </div>
                    <div className='status-content'>
                        <p>{title}</p>
                        <h4>{count}</h4>
                        {/* <Link to="/ro/epb-pin-download" className='button-link'>View</Link> */}
                    </div>
                </div>
        
        </div>
    );
}

